<template>
  <hm-content title="">
    <div class="flex flex-end">
      <el-select
        clearable
        v-model="searchCondition.shopId"
        placeholder="搜索/选择门店"
        size="small"
        filterable
        class="mr10"
      >
        <el-option
          :label="v.shopName"
          :value="v.shopId"
          v-for="(v, i) in shopList.records"
          :key="i"
        ></el-option>
      </el-select>
      <el-input
        clearable
        v-model.trim="searchCondition.cardMobile"
        placeholder="请输入会员手机号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        clearable
        v-model.trim="searchCondition.cardNo"
        placeholder="请输入卡号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-date-picker
        clearable
        :default-time="['00:00:00', '23:59:59']"
        v-model="searchCondition.openDate"
        type="datetimerange"
        align="right"
        start-placeholder="请选择开卡时间段"
        end-placeholder="请选择开卡时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
      >
      </el-date-picker>
      <el-select
        clearable
        class="mr10"
        style="width:200px"
        size="small"
        v-model="searchCondition.employeeId"
        placeholder="请输入所属导购姓名"
        filterable
      >
        <el-option
          :label="v.realname"
          :value="v.employeeId"
          :key="i"
          v-for="(v, i) in allEmployee"
        ></el-option>
      </el-select>
    </div>

    <el-form
      :inline="true"
      :model="searchCondition"
      :rules="rules"
      ref="ruleForm"
    >
      <div class="flex flex-end item-center" style="white-space:nowrap">
        <el-form-item prop="applyDate" label="购买时间">
          <el-date-picker
            clearable
            :default-time="['00:00:00', '23:59:59']"
            v-model="searchCondition.applyDate"
            type="datetimerange"
            align="right"
            start-placeholder="请选择购买时间段"
            end-placeholder="请选择购买时间段"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
            style="width:350px"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="categoryBeforeId">
          即买了
          <el-cascader
            v-model="searchCondition.categoryBeforeId"
            :show-all-levels="false"
            size="small"
            class=""
            :props="categoryProp"
            clearable
            placeholder="请选择商品分类"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="queryType">
          <el-select
            size="small"
            style="width:100px"
            v-model="searchCondition.queryType"
          >
            <el-option label="又买了" value="yes"></el-option>
            <el-option label="又未买" value="no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="categoryAfterId">
          <el-cascader
            v-model="searchCondition.categoryAfterId"
            :show-all-levels="false"
            size="small"
            class=""
            :props="categoryProp"
            clearable
            placeholder="请选择商品分类"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="search('ruleForm')"
            style="height:32px"
            >查询</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="output"
            :loading="isOutputing"
            >导出</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <div class="table-panel flex flex-center"></div>
    <div>
      <el-table
        :data="list"
        style="width: 100%"
        ref="table"
        stripe
        size="small"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardMobile"
          label="会员手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardNo"
          label="会员卡号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="fullName"
          label="会员姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="opencardTime"
          label="开卡时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="归属导购"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="babyBirthday"
          label="宝宝生日"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalConsumption"
          label="累计消费金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="lastSaleTime"
          label="最后一次购买时间"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { ToFixed } from "@/utils/utils";
import {getLoginUser} from "@/utils/auth";
export default {
  data() {
    // const patternFunc = (rule, val, callback) => {
    //   console.log("val: ", val);
    //   callback();
    // };
    return {
      storeCode: "",
      isOutputing: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      searchCondition: {
        applyDate: [],
        openDate: [],
        categoryBeforeId: [],
        categoryAfterId: [],
        queryType: "yes"
      },
      rules: {
        applyDate: {
          required: true,
          message: "请选择购买时间",
          trigger: "change"
        },
        categoryAfterId: [
          {
            required: true,
            message: "请选择商品分类"
          }
          // {
          //   required: true,
          //   validator: patternFunc
          // }
        ],
        queryType: {
          required: true,
          message: "请选择"
        },
        // categoryBeforeId: {
        //   required: true,
        //   message: "请选择商品分类"
        // }
      },
      allEmployee: [],
      dkShops: [],
      categoryProp: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  computed: mapGetters([
    "shopList",
    "dkMicroShopStoreList"
  ]),
  created() {},
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.queryShopList();
    this.queryAllEmployeeList();
  },
  methods: {
    // 导出excel
    output() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          require.ensure([], () => {
            const {
              exportJsonToExcel
            } = require("@/utils/output/Export2Excel");
            this.isOutputing = true;

            this.queryAllList()
              .then(res => {
                console.log("res: ", res);
                let list = res;
                list.forEach(v => {
                  v.totalConsumption = ToFixed(v.totalConsumption || 0, 2);
                });
                let tHeader = this.$refs.table.columns
                  .map(o => o.label !== "序号" && o.label)
                  .filter(o => o);
                let filterVal = [];
                if (list.length > 0) {
                  filterVal = this.$refs.table.$children
                    .map(o => o._props.prop)
                    .filter(o => o);
                }

                let title = "交叉报表";

                let data = this.formatJson(filterVal, list);

                exportJsonToExcel(
                  tHeader,
                  data,
                  title + new Date().toLocaleString()
                );
                this.isOutputing = false;
              })
              .catch(() => {
                this.isOutputing = false;
              });
          });
        } else {
          return false;
        }
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    search(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.currentPage = 1;
          this.queryList();
        } else {
          return false;
        }
      });
    },
    async queryAllList() {
      let params = {
        pageSize: 999999,
        pageNo: 1,
        useMode: "export",
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.opencardStartTime =
        this.searchCondition.openDate &&
        this.searchCondition.openDate.length > 0
          ? this.searchCondition.openDate[0]
          : "";
      searchCondition.opencardEndTime =
        this.searchCondition.openDate &&
        this.searchCondition.openDate.length > 0
          ? this.searchCondition.openDate[1]
          : "";
      searchCondition.startDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      if(this.searchCondition.categoryBeforeId.length>0){    
        searchCondition.firstCategoryId = [
          this.searchCondition.categoryBeforeId[
            this.searchCondition.categoryBeforeId.length - 1
          ]
        ];
      }
      searchCondition.secondCategoryId = [
        this.searchCondition.categoryAfterId[
          this.searchCondition.categoryAfterId.length - 1
        ]
      ];

      Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch(
        "queryCrossCategoryAllList",
        params
      );
      return result.records;
    },
    async queryList() {
      if (
        this.isArray(this.searchCondition.categoryBeforeId) &&
        this.isArray(this.searchCondition.categoryAfterId)
      ) {
        let params = {
          pageSize: this.pageSize,
          pageNo: this.currentPage,
          useMode: "query",
        };

        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );

        searchCondition.opencardStartTime =
          this.searchCondition.openDate &&
          this.searchCondition.openDate.length > 0
            ? this.searchCondition.openDate[0]
            : "";
        searchCondition.opencardEndTime =
          this.searchCondition.openDate &&
          this.searchCondition.openDate.length > 0
            ? this.searchCondition.openDate[1]
            : "";
        searchCondition.startDate =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "";
        searchCondition.endDate =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : "";
        if(this.searchCondition.categoryBeforeId.length>0){
          searchCondition.firstCategoryId = [
            this.searchCondition.categoryBeforeId[
              this.searchCondition.categoryBeforeId.length - 1
            ]
          ];
        }
        searchCondition.secondCategoryId = [
          this.searchCondition.categoryAfterId[
            this.searchCondition.categoryAfterId.length - 1
          ]
        ];

        Object.assign(params, searchCondition);

        const { code, result } = await this.$store.dispatch(
          "queryCrossCategoryList",
          params
        );

        if (code === "0") {
          const { total, records } = result;
          this.total = total;
          records.forEach(v => {
            v.totalConsumption = ToFixed(v.totalConsumption || 0, 2);
          });
          this.list = records;
          console.log("result: ", result);
        }
      }
    },
    async queryAllEmployeeList() {
      const { result } = await this.$store.dispatch("queryEmployeeList", {
        pageNo: 1,
        pageSize: 9999,
        workingState: "yes",
        loginType: "store"
      });
      this.allEmployee = result.records;
    },
    queryShopList() {
      this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 99999
      });
    },
  }
};
</script>

<style scoped lang="scss"></style>
